import * as React from 'react';
import { InputProp } from '@lendi-ui/text-input';
import Field from '@lendi-ui/field';

import { EventTracking } from '@funnels/types';
import { UseNumeralOptions } from '@funnels/hooks';

import { FieldLabel } from '../../_common/FieldLabel';
import { FieldWrapper } from '../../_common/style';
import UncontrolledNumericalInput from '../NumericalInput';
export interface UncontrolledNumericalInputFieldProps extends EventTracking, Omit<InputProp, 'name' | 'onChange'> {
  label?: string;
  subLabel?: string;
  digitsLimit?: number;
  isDecimalValid?: boolean;
  isZeroValid?: boolean;
  isError?: boolean;
  maxValue?: string;
  minValue?: string;
  onChange?: (value?: number) => void;
}

function UncontrolledNumericalInputField(props: UncontrolledNumericalInputFieldProps) {
  const { label, subLabel, digitsLimit, isDecimalValid, maxValue, minValue, ...otherProps } = props;
  const options: UseNumeralOptions = {
    fixed: !!isDecimalValid,
    maxValue,
    minValue,
  };
  const digitsLimitProps = digitsLimit ? { maxLength: digitsLimit } : {};

  return (
    <FieldWrapper>
      <FieldLabel label={label} subLabel={subLabel} />
      <Field>
        <UncontrolledNumericalInput {...digitsLimitProps} {...otherProps} options={options} isFullWidth />
      </Field>
    </FieldWrapper>
  );
}

export default UncontrolledNumericalInputField;
